module.exports = __webpack_public_path__ + "static/media/logo_rebrand.6b25e675.svg";